import React, { useState } from 'react';
import { Typography } from '@material-ui/core';
import { IDocumentUser } from '../../api-client/autogenerated';
import { editDocumentSettings } from '../../models/api/documents';
import { useDispatch, useSelector } from 'react-redux';
import { getUserState } from '../../features/user/selectors';
import { getDocumentState } from '../../features/document/selectors';
import { ToggleButtonGroup } from '@material-ui/lab';
import { GreenToggleButton, RedToggleButton } from '../custom-components/CustomButtons';
import { updateDocument } from '../../features/document/actions';
import CircularLoader from '../loader/CircularLoader';
import { getProjectIsArchived } from '../../features/project/selectors';

interface Props {
  documentUser: IDocumentUser;
}

export default function NotificationsForm(props: Props) {
  const { documentUser } = props;

  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const user = useSelector(getUserState);
  const document = useSelector(getDocumentState)!;
  // Toggling reminders writes a document_user row, which an archived project no longer accepts.
  const isArchivedProject = useSelector(getProjectIsArchived);

  const handleSubmit = async (value: boolean) => {
    setIsLoading(true);
    try {
      await editDocumentSettings(user.id, document.id, value);
      dispatch(
        updateDocument({
          documentUserList: [
            ...(document.documentUserList?.filter((x) => x.userId !== user.id) || []),
            { ...documentUser, areNotificationsDisabled: value },
          ],
        }),
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Typography>Document Notifications & Reminders</Typography>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <ToggleButtonGroup
          exclusive
          value={documentUser.areNotificationsDisabled}
          onChange={(_, value) => handleSubmit(value)}
          style={{ marginTop: 8 }}
        >
          <GreenToggleButton value={false} style={{ width: 80 }} disabled={isArchivedProject}>
            On
          </GreenToggleButton>
          <RedToggleButton value={true} style={{ width: 80 }} disabled={isArchivedProject}>
            Off
          </RedToggleButton>
        </ToggleButtonGroup>
        <CircularLoader
          size={40}
          style={{ visibility: isLoading ? 'visible' : 'hidden', marginLeft: 32, marginTop: 6 }}
        />
      </div>
    </div>
  );
}
